import { render, staticRenderFns } from "./ValoresCartera.vue?vue&type=template&id=5bf81682&"
import script from "./ValoresCartera.vue?vue&type=script&lang=js&"
export * from "./ValoresCartera.vue?vue&type=script&lang=js&"
import style0 from "./ValoresCartera.vue?vue&type=style&index=0&id=5bf81682&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports